import { Application, Catalogue } from '../../common';
import { DeliveryDetails } from '../types/delivery-details';
import { getDeliveryDetails } from '../helpers/get-delivery-details';
import { useMemo } from 'react';

export function useDeliveryDetails(
  application: Application,
  catalogue: Catalogue,
): DeliveryDetails {
  const deliveryDetails = useMemo(() => getDeliveryDetails(application, catalogue), [
    application,
    catalogue,
  ]);

  return deliveryDetails;
}
